const compatModules = {};import * as Mod1 from "./discourse/components/post-signature";
compatModules["discourse/components/post-signature"] = Mod1;

export * as discourse$components$post__signature$$__module from "./discourse/components/post-signature";
export {
addSignatureDecorator as discourse$components$post__signature$$addSignatureDecorator,
resetSignatureDecorators as discourse$components$post__signature$$resetSignatureDecorators,
default as discourse$components$post__signature$$default
} from "./discourse/components/post-signature";
import * as Mod2 from "./discourse/connectors/user-custom-preferences/signature-preferences.gjs";
compatModules["discourse/connectors/user-custom-preferences/signature-preferences"] = Mod2;

export * as discourse$connectors$user__custom__preferences$signature__preferences$$__module from "./discourse/connectors/user-custom-preferences/signature-preferences.gjs";
export {
default as discourse$connectors$user__custom__preferences$signature__preferences$$default
} from "./discourse/connectors/user-custom-preferences/signature-preferences.gjs";
import * as Mod3 from "./discourse/initializers/extend-for-signatures";
compatModules["discourse/initializers/extend-for-signatures"] = Mod3;

export * as discourse$initializers$extend__for__signatures$$__module from "./discourse/initializers/extend-for-signatures";
export {
default as discourse$initializers$extend__for__signatures$$default
} from "./discourse/initializers/extend-for-signatures";
import * as Mod4 from "./discourse/pre-initializers/signatures-plugin-api";
compatModules["discourse/pre-initializers/signatures-plugin-api"] = Mod4;

export * as discourse$pre__initializers$signatures__plugin__api$$__module from "./discourse/pre-initializers/signatures-plugin-api";
export {
default as discourse$pre__initializers$signatures__plugin__api$$default
} from "./discourse/pre-initializers/signatures-plugin-api";
export default compatModules;
